import { create } from 'zustand';
import type {
  FirstStepFormData,
  SecondStepFormData,
  ThirdStepFormData,
} from '~/@types/MarisaTakesCare/form';

interface TakesCareFormState {
  states: {
    firstStep: FirstStepFormData;
    secondStep: SecondStepFormData;
    thirdStep: ThirdStepFormData;
  };
  functions: {
    setFirstStepData: (formState: FirstStepFormData) => void;
    setSecondStepData: (formState: SecondStepFormData) => void;
    setThirdStepData: (formState: ThirdStepFormData) => void;
  };
}

export const useTakesCareFormStore = create<TakesCareFormState>((set) => ({
  states: {
    firstStep: {} as FirstStepFormData,
    secondStep: {} as SecondStepFormData,
    thirdStep: {} as ThirdStepFormData,
  },
  functions: {
    setFirstStepData: (formState) =>
      set((currentState) => ({
        states: { ...currentState.states, firstStep: formState },
      })),
    setSecondStepData: (formState) =>
      set((currentState) => ({
        states: { ...currentState.states, secondStep: formState },
      })),
    setThirdStepData: (formState) =>
      set((currentState) => ({
        states: { ...currentState.states, thirdStep: formState },
      })),
  },
}));
